export default function TwitterIcon({ socialIconClass }) {
  return (
    // <svg
    //   className={socialIconClass}
    //   id='Twitter'
    //   xmlns='http://www.w3.org/2000/svg'
    //   width='34.82'
    //   height='34.82'
    //   viewBox='0 0 34.82 34.82'>
    //   <path
    //     id='Path_21'
    //     data-name='Path 21'
    //     d='M34.82,17.41A17.41,17.41,0,1,1,17.41,0,17.41,17.41,0,0,1,34.82,17.41'
    //     fill='#fff'
    //   />
    //   <path
    //     id='Path_22'
    //     data-name='Path 22'
    //     d='M28.471,34.548c2.465,2.669,5.151,4.44,8.316,4.27-.045-4.045,2.953-6.384,7.192-3.506l2.382-1.034L45.013,36.3l1.843-.315-1.843,1.708c-.45,11.462-10.338,14.249-17.576,10.473,2.441-.152,4.356-.623,5.484-1.573A4.6,4.6,0,0,1,29.5,43.763l1.483-.09c-1.629-.553-2.57-1.929-2.967-3.955l1.573.135c-1.561-1.321-1.757-3.157-1.124-5.3'
    //     transform='translate(-19.736 -24.482)'
    //     fill='#2572a2'
    //   />
    // </svg>

    <svg className={socialIconClass} viewBox='0 0 58.23 58.23' fill='#fff'>
      <polygon points='16.94 15.16 37.96 43.06 41.29 43.06 20.27 15.16 16.94 15.16' />
      <path d='M29.11,0C13.03,0,0,13.03,0,29.11s13.03,29.11,29.11,29.11,29.11-13.03,29.11-29.11S45.19,0,29.11,0Zm7.14,46.48l-9.12-12.1-10.69,12.11h-5.8l13.82-15.65L10.06,11.73h11.91l8.45,11.21,9.86-11.21h5.79l-12.98,14.76,15.06,19.99h-11.91Z' />
    </svg>
  );
}
